import { Tooltip } from 'antd'
import { Button } from '@/components/ui/button'

interface ActionIconProps {
  title: string
  Icon: React.ComponentType<any>
  className?: string
  loading?: boolean
  [key: string]: any
}

const ActionIcon = ({
  title,
  Icon,
  className,
  loading,
  ...rest
}: ActionIconProps) => {
  return (
    <Tooltip title={title} placement="top">
      <Button
        size="iconsm"
        variant="ghost"
        className={className}
        // className="!w-7 h-7 flex justify-center items-center text-xs gap-1"
        disabled={loading}
        {...rest}
      >
        <Icon strokeWidth={1.5} size={20} />
      </Button>
    </Tooltip>
  )
}

export default ActionIcon
